/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	let el = document.createElement('script');
	if (location.pathname !== '/search.html') {
		el.src = '//ce.mf.marsflag.com/latest/js/mf-search.js';
	}
	setTimeout(function () {
		document.body.appendChild(el);
	}, 100);

})(window.FUNCTIONS);
